import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { bulkRestore } from 'email-management-lib/EmailRestore/api/restore';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RestoreModal({
  crmObjects,
  onClose,
  listingLibObserver
}) {
  const count = crmObjects.length;
  const removeFromFrameworkTable = useCallback(() => {
    if (listingLibObserver) {
      listingLibObserver.delete(crmObjects.map(object => object.objectId));
    }
  }, [crmObjects, listingLibObserver]);
  const onRestore = useCallback(() => {
    const emailIds = crmObjects.map(object => Number(getPropertyValue(object, PROPERTIES.MARKETING_EMAIL_ID)));
    bulkRestore(emailIds).then(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('email-management.emailRestore.alert.success', {
          count
        }),
        type: 'success'
      });
      removeFromFrameworkTable();
    }).catch(error => {
      Raven.captureException(new Error('Error when restoring emails'), {
        extra: {
          error: error.responseJSON || error
        }
      });
      FloatingAlertStore.addAlert({
        message: I18n.text('email-management.errors.email.restore', {
          count
        }),
        type: 'danger'
      });
    });
    onClose();
  }, [crmObjects, count, onClose, removeFromFrameworkTable]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "email-restore-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailRestore.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "restore-modal-close",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "strong",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailRestore.body.keepInMind"
        })
      }), /*#__PURE__*/_jsxs(List, {
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailRestore.body.mind1"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailRestore.body.mind2"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailRestore.body.mind3"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: onRestore,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailRestore.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailRestore.cancel"
          })
        })]
      })
    })]
  });
}